<template>
  <div class="mobile__bottom-menu">
    <nav class="mobile__bottom-menu-nav">
      <router-link
        v-for="(item, i) in links"
        :key="i"
        :to="item.route"
        class="mobile__bottom-menu-link"
        :class="{ active: isRouteActive(item.route) }"
      >
        <IconComponent :name="item.icon" />
        <span>{{ item.title }}</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "MobileBottomMenuComponent",
  components: { IconComponent },
  data() {
    return {
      links: [
        {
          icon: "house-1",
          title: "Главная",
          route: { name: "home" },
        },
        {
          icon: "category",
          title: "Каталог",
          route: { name: "catalog" },
        },
        {
          icon: "heart",
          title: "Избранное",
          route: { name: "user", params: { link: "wishlist" } },
        },
        {
          icon: "bag-2",
          title: "Корзина",
          route: { name: "cart" },
        },
        {
          icon: "profile",
          title: "Профиль",
          route: { name: "user", params: { link: "profile" } },
        },
      ],
    };
  },
  methods: {
    isRouteActive(route) {
      return this.$route.name === route.name && this.$route?.params?.link === route?.params?.link;
    },
  },
};
</script>

<style lang="stylus">
.mobile__bottom-menu {
  position fixed
  bottom 0
  left 0
  right 0
  z-index 9
  height 60px
  padding 7px 0
  background var(--gray)
  display flex

  +above(769px) {
    display none
  }

  &-nav {
    display flex
    gap 5px
    margin 0 auto
  }

  &-link {
    display flex
    flex-direction column
    align-items center
    justify-content center
    gap 2px
    font-size 0.75em
    width 66px
    padding 5px
    flex-shrink 0
    border-radius var(--main_radius)
    +below(380px) {
      width 50px
      background var(--gray-2-dark)
      flex-shrink 1
    }

    .icon {
      width 25px
      height 25px
      +below(380px) {
        width 30px
        height 30px
      }
    }

    span {
      line-height 1
      +below(380px) {
        display none
      }
    }

    &.active {
      color var(--main-color-75)

      .icon {
        svg path {
          stroke var(--main-color-75)
        }
      }
    }
  }
}
</style>
